export const RESET_STATE_MODAL_TAG = 'RESET_STATE_TAG';
